import { render, staticRenderFns } from "./LinkdeConviteEvent_New.vue?vue&type=template&id=49550a72&scoped=true"
import script from "./LinkdeConviteEvent_New.vue?vue&type=script&lang=js"
export * from "./LinkdeConviteEvent_New.vue?vue&type=script&lang=js"
import style0 from "./LinkdeConviteEvent_New.vue?vue&type=style&index=0&id=49550a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49550a72",
  null
  
)

export default component.exports